/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * The project fields to update. Only fields whose paths are listed in `updateMask`
 * will be applied; all other fields in this object are ignored.
 * @export
 * @interface UpdateProjectRequestProject
 */
export interface UpdateProjectRequestProject {
    /**
     * The display name of the application, shown to end users during the connection flow.
     * @type {string}
     * @memberof UpdateProjectRequestProject
     */
    appName?: string;
    /**
     * The unique name for the project. Must be unique within the organization.
     * @type {string}
     * @memberof UpdateProjectRequestProject
     */
    name?: string;
}

/**
 * Check if a given object implements the UpdateProjectRequestProject interface.
 */
export function instanceOfUpdateProjectRequestProject(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateProjectRequestProjectFromJSON(json: any): UpdateProjectRequestProject {
    return UpdateProjectRequestProjectFromJSONTyped(json, false);
}

export function UpdateProjectRequestProjectFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateProjectRequestProject {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'appName': !exists(json, 'appName') ? undefined : json['appName'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function UpdateProjectRequestProjectToJSON(value?: UpdateProjectRequestProject | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'appName': value.appName,
        'name': value.name,
    };
}

